import useScreen from "Hooks/useScreen";
import { TabItem } from "elements/TabsSymphony";
import { CSSProperties } from "react";
import ButtonSymphony from "./ButtonSymphony";
import { clsx, styx } from "modules/Utils";
import Sty from "modules/Sty";
import useMaestroChat from "Hooks/useMaestroChat";
import { PREV_NEXT_FOOTER_HEIGHT } from "modules/Const";

interface PrevNextFooterProps {
    className?: string;
    style?: CSSProperties;
    tabs: TabItem[];
    currentTab: TabItem | string;
    handlePrevTab: () => void;
    handleNextTab: () => void;
    isAboveContainer?: boolean;
    aboveContainerChildren?: React.ReactNode;
    styleAboveContainer?: CSSProperties;
    maxWidth?: number;
    nextButtonLabel?: string;
    isNextButtonDisabled?: boolean;
    isNextButtonHidden?: boolean;
}

const PrevNextFooter = ({
    className,
    style,
    tabs,
    currentTab,
    handlePrevTab,
    handleNextTab,
    isNextButtonHidden = false,
    isAboveContainer = false,
    aboveContainerChildren,
    styleAboveContainer,
    maxWidth = 680,
    nextButtonLabel = 'Next',
    isNextButtonDisabled = false,
}: PrevNextFooterProps) => {

    const {
        isChatOpen,
        setIsChatOpen
    } = useMaestroChat()

    const { mStyle, mobileView } = useScreen();

    const isFirstTab = typeof currentTab === 'string'
        ? currentTab === tabs[0]?.id
        : currentTab?.id === tabs[0]?.id;
    const isLastTab = typeof currentTab === 'string'
        ? currentTab === tabs[tabs.length - 1]?.id
        : currentTab?.id === tabs[tabs.length - 1]?.id;

    return (
        <div
            className={clsx('prevNextFooterElement', className)}
            style={styx(
                mStyle(sty, 'prevNextFooterElement'),
                style
            )}
        >
            {mobileView && isAboveContainer && aboveContainerChildren &&
                <div 
                    className="campaignViewExtraModalContainer"
                    style={styx(
                        sty.campaignViewExtraModalContainer,
                        styleAboveContainer
                    )}
                >
                    {aboveContainerChildren}
                </div>
            }
            <div
                className="campaignNavigationButtonsInner"
                style={styx(
                    mStyle(sty, 'campaignNavigationButtonsInner'),
                    { maxWidth }
                )}
            >
                <ButtonSymphony
                    className="campaignNavigationButtonPrev"
                    onClick={() => handlePrevTab()}
                    variant={isFirstTab ? 'primary' : 'outlined'}
                    disabled={isFirstTab}
                >
                    {isFirstTab ? 'Back' : 'Prev'}
                </ButtonSymphony>
                {/* <Banner
                    color="maestro"
                    className="campaignNavigationButtonMaestroBanner"
                    style={{
                        padding: '8px 16px'
                    }}
                >
                    <ButtonSymphony
                        className="campaignNavigationButtonMaestroButton"
                        onClick={() => {
                            setIsChatOpen(true)
                        }}
                        variant="text"
                    >
                        Ask Maestro
                    </ButtonSymphony>
                </Banner> */}
                <ButtonSymphony
                    className="campaignNavigationButtonNext"
                    onClick={() => handleNextTab()}
                    disabled={isNextButtonDisabled}
                    style={{ display: isNextButtonHidden ? 'none' : 'block' }}
                >
                    {isLastTab ? 'Finish' : nextButtonLabel}
                </ButtonSymphony>
            </div>
        </div>
    );
};

const sty: Record<string, CSSProperties> = {
    prevNextFooterElement: {
        position: 'fixed',
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '100%',
        height: PREV_NEXT_FOOTER_HEIGHT,
        boxShadow: Sty.boxShadowTop,
    },
    campaignNavigationButtonsInner: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 16,
        width: '100%',
        paddingLeft: 0,
        paddingRight: 0,
    },
    campaignNavigationButtonsInner_mobile: {
        paddingLeft: 16,
        paddingRight: 16,
    },
    campaignViewExtraModalContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        position: 'absolute',
        bottom: 72,
        height: 40,
        zIndex: 1000,
        backgroundColor: 'white',
        borderBottom: Sty.border,
        borderTop: Sty.border,
    }
};

export default PrevNextFooter;